/**
 * Thin seam over the browser reload.
 *
 * `window.location` is non-configurable in jsdom, so callers that route their
 * reload through this module stay testable without stubbing the global.
 */
export function reloadPage(): void {
  window.location.reload();
}
